<template>
  <div class="inventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader :pageHeader="listPageHeader" :links="[
        { name: 'home', label: 'Home' },
        { name: 'products', label: 'Products' },
      ]" :entity="entity">
        <!-- <Button label="Sync Products" iconGroup="fas" iconName="file-export" :colorType="2" @click="syncProducts()" :isLoading="stateLoadingStatus.pullProducts" /> -->
      </PageHeader>

      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort" :pagination="pagination"
        :filterButtons="filterButtons" @filterButtonsChange="updateFilterButtons" :enableAdditionalFilter="true"
        @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import Entities from "@/resources/Entities";
import SearchTable from "@/components/SearchTable.vue";
import Button from "@/components/Base/Button/Button.vue";

import { listPageHeader } from "./inputs";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "products",
  data() {
    return {
      listPageHeader,
      entity: Entities.PRODUCT,
    };
  },
  components: {
    PageHeader,
    SearchTable,
    // Button,
  },
  created: function () {
    this.setPageTitle("Products");
  },
  computed: {
    ...mapGetters({
      sort: "productModule/sort",
      pagination: "productModule/pagination",
      initialFilter: "productModule/initialFilter",
      filterButtons: "productModule/filterButtons",
      stateLoadingStatus: "stateModule/loadingStatus",
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "productModule/updateSort",
      updatePagination: "productModule/updatePagination",
      updateInitialFilter: "productModule/updateInitialFilter",
      updateFilterButtons: "productModule/updateFilterButtons",
      pullProducts: "stateModule/pullProducts",
      setMessage: "setMessage",
    }),
    syncProducts() {
      const positiveCallback = (response) => {
          const {successCount, failedProducts} = response

          if(failedProducts?.length > 0) {
            const failedProductsNames = failedProducts?.map(m => m.message).join("\n");
            this.setMessage({
              title: "Partial State Sync",
              text: "Synced " + successCount + " products.\n\nFailed to sync " + failedProducts.length + " products:\n" + failedProductsNames,
              type: "state-error"
            });
            return;
          }

          const text = successCount > 0 ? "Synced " + successCount + " product(s)!" : "Up to date!";
          this.setMessage({
            isOpen: true,
            text: text,
            type: "success"
          });
      };

      this.pullProducts({positiveCallback});
    },
  }
};
</script>
